module.exports = __webpack_public_path__ + "static/media/paleta.91f4994e.jpeg";